import { useEffect, useState } from "react";
import { DurationFilterOptions, MoreFilterMapping } from "../../features/searchpage/constants/filters.constants";
import "./date-range-dropdown.scss";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";

const DateRangeDropdown = ({ fieldKey, selectedFilters, onSetDateRangeDropdown }: any) => {
  const durationFilterOptions = DurationFilterOptions;

  const onChangeDateRangeDropdown = (val: number) => {
    if (val > 1) {
      let dt = new Date();
      let dtNum = new Date(dt.setDate(dt.getDate() - val));
      let data = {
        [MoreFilterMapping[fieldKey]['apiKey']]: val,
        'fromDate': dtNum,
        'toDate': dt
      }
      onSetDateRangeDropdown(data);
    } else {
      let data = {
        [MoreFilterMapping[fieldKey]['apiKey']]: val,
      }
      onSetDateRangeDropdown(data);
    }
  }

  const onChangeDate = (value: any, key: string) => {
    let data = {
      [key]: value,
    }
    onSetDateRangeDropdown(data);
  }

  return (
    <>
      <Dropdown value={selectedFilters[MoreFilterMapping[fieldKey]['apiKey']]} onChange={(e) => onChangeDateRangeDropdown(e.value)} options={durationFilterOptions}
        placeholder="Select a Duration" />
      {
        MoreFilterMapping[fieldKey]?.keyChild?.length && selectedFilters[MoreFilterMapping[fieldKey]['apiKey']] == 1 ?
          MoreFilterMapping[fieldKey]?.keyChild.map((key: string, index:number) =>
            <Calendar key={`Calendar${key}${index}`} value={selectedFilters[key]} dateFormat="dd/mm/yy"
              showIcon
              onChange={(e: any) => {
                onChangeDate(e.value, MoreFilterMapping[key]['apiKey'])
              }}  ></Calendar>

          )
          : ''
      }
    </>
  );
};

export default DateRangeDropdown;
